<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxContactCell from "../../../../../../_shared/_modules/inbox-contact-cell"
  import type { AssignRequesterCustomerDraft, AssignRequesterCustomerRow } from "../../contract"

  let { row }: InboxWorkflowCellProps<AssignRequesterCustomerRow, AssignRequesterCustomerDraft> =
    $props()
</script>

{#if row.customerOptions.length}
  <div class="customers">
    {#each row.customerOptions as customer (customer.customerId)}
      <InboxContactCell
        label={customer.displayName}
        roleLabel={customer.role}
        email={customer.email}
        phone={customer.phone}
        unitLabel={row.unitLabel}
        disabled={row.disabled}
      />
    {/each}
  </div>
{:else}
  <span class:disabled={row.disabled}>—</span>
{/if}

<style>
  .customers {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    max-width: 100%;
  }

  span {
    color: var(--text-invers-100);
  }

  span.disabled {
    opacity: 0.54;
  }
</style>
